/**
 * Reads `required_fields` from the query string. Accepts CSV or Django-style
 * `['a', 'b']` / `["a","b"]` (outer brackets and per-token quotes are stripped).
 * All non-empty tokens are returned; match them to form field `name` props to highlight.
 */
export function parseRequiredFieldsFromSearch(search: string): Set<string> {
  const out = new Set<string>();
  const raw = new URLSearchParams(search).get('required_fields');
  if (!raw?.trim()) return out;

  let inner = raw.trim();
  if (inner.startsWith('[') && inner.endsWith(']')) {
    inner = inner.slice(1, -1).trim();
  }

  for (const part of inner.split(',')) {
    let key = part.trim();
    if (key.startsWith('[')) key = key.slice(1).trim();
    if (key.endsWith(']')) key = key.slice(0, -1).trim();
    const quoted =
      (key.startsWith("'") && key.endsWith("'")) || (key.startsWith('"') && key.endsWith('"'));
    if (quoted && key.length >= 2) {
      key = key.slice(1, -1).trim();
    }
    if (key) out.add(key);
  }
  return out;
}

export function formatPersonalNumber(val: string): string {
    if (!val) return '';
    const digits = val.replace(/\D/g, '');
    if (digits.length <= 8) return digits;
    return digits.slice(0, -4) + '-' + digits.slice(-4);
  }

export function parsePersonalNumber(val: string): string {
    return (val || '').replace(/\D/g, '');
  }